import { SOURCE_DOCUMENT_ACCEPT, SOURCE_INPUT_UPLOAD_HINT } from '../../../domain/sourceAttachmentPolicy';

export const ideaModalMarkup = String.raw`<!-- Submit Idea Modal — 3-Step Wizard -->
<div class="modal-overlay" id="submitIdeaModal" data-transient-action>
  <div class="modal modal--lg">
    <div class="modal-header">
      <div class="modal-heading">
        <h3 class="modal-title">Submit an Idea</h3>
        <p class="modal-description">Propose a topic with source references. The community votes on what DeepMox builds next.</p>
      </div>
      <button type="button" class="modal-close" data-proto-click="closeSubmitIdea()" aria-label="Close submit idea dialog">
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <!-- Step indicator -->
    <div class="wizard-steps" id="wizardSteps">
      <div class="wizard-step active" data-step="1">
        <span class="wizard-step-num">1</span>
        <span class="wizard-step-label">Basics</span>
      </div>
      <div class="wizard-step-line"></div>
      <div class="wizard-step" data-step="2">
        <span class="wizard-step-num">2</span>
        <span class="wizard-step-label">References</span>
      </div>
      <div class="wizard-step-line"></div>
      <div class="wizard-step" data-step="3">
        <span class="wizard-step-num">3</span>
        <span class="wizard-step-label">Details</span>
      </div>
    </div>
    <div class="modal-body">
	  <p id="ideaFormAlert" class="operation-feedback" role="alert" aria-live="assertive" data-transient-feedback hidden></p>
      <!-- Step 1: Title + Category -->
      <div class="wizard-panel active" id="wizardPanel1">
        <div style="margin-bottom:20px;">
          <label class="wizard-label">Title</label>
          <input type="text" class="input" id="ideaTitle" maxlength="120" autocomplete="off" placeholder="e.g. How RAG Systems Work in Production">
        </div>
        <div style="margin-bottom:20px;">
          <label class="wizard-label">Subtitle <span style="font-weight:400;color:var(--fg-tertiary);">(optional)</span></label>
          <input type="text" class="input" id="ideaSubtitle" maxlength="120" autocomplete="off" placeholder="A short tagline shown under the title">
        </div>
        <div>
          <button type="button" class="btn btn-primary btn-lg w-full" data-proto-click="wizardNext(2)" style="margin-top:28px;">Continue</button>
        </div>
      </div>
      <!-- Step 2: Sources -->
      <div class="wizard-panel" id="wizardPanel2">
        <p style="font-size:12px;color:var(--fg-tertiary);margin:-4px 0 18px;">${SOURCE_INPUT_UPLOAD_HINT}</p>
        <div data-source-section="attachments">
          <label class="wizard-label">Attachments</label>
          <div id="ideaAttachmentList" style="display:flex;flex-direction:column;gap:6px;margin-bottom:8px;"></div>
          <button type="button" id="ideaAddAttachmentBtn" data-proto-click="addIdeaAttachment()" class="wizard-add-btn">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
            Attach file · max 30 MB
          </button>
          <input type="file" id="ideaAttachmentInput" style="display:none;" accept="${SOURCE_DOCUMENT_ACCEPT}" data-proto-change="handleIdeaAttachment(this)">
        </div>
        <div class="source-input-divider" aria-hidden="true"><span>OR</span></div>
        <div data-source-section="reference-links">
          <label class="wizard-label">Reference Links</label>
          <div id="ideaLinkList" style="display:flex;flex-direction:column;gap:8px;">
            <div class="idea-link-row">
              <input type="url" class="input idea-link-url" maxlength="2048" autocomplete="off" placeholder="https://...">
              <input type="text" class="input idea-link-desc" maxlength="64" autocomplete="off" placeholder="Link description">
              <span style="width:32px;flex-shrink:0;"></span>
            </div>
          </div>
          <p style="font-size:11px;color:var(--fg-tertiary);margin-top:6px;">Reference links must be valid https URLs.</p>
          <button type="button" id="ideaAddLinkBtn" data-proto-click="addIdeaLink()" class="wizard-add-btn">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            Add another link
          </button>
        </div>
        <div class="modal-actions modal-actions--split">
          <button class="btn btn-outline btn-lg wizard-back-btn" data-proto-click="wizardNext(1)">
            Back
          </button>
          <button type="button" class="btn btn-primary btn-lg" data-proto-click="wizardNext(3)">Continue</button>
        </div>
      </div>
      <!-- Step 3: Expected strengths/weaknesses -->
      <div class="wizard-panel" id="wizardPanel3">
        <div style="margin-bottom:20px;">
          <label class="wizard-label">Expected Strengths <span style="font-weight:400;color:var(--fg-tertiary);">(optional)</span></label>
          <textarea class="input" id="ideaStrengths" rows="2" maxlength="300" autocomplete="off" placeholder="What aspects should this topic excel at? e.g. practical code examples, real-world case studies..." style="line-height:1.5;"></textarea>
        </div>
        <div style="margin-bottom:24px;">
          <label class="wizard-label">Areas to Go Deeper <span style="font-weight:400;color:var(--fg-tertiary);">(optional)</span></label>
          <textarea class="input" id="ideaWeaknesses" rows="2" maxlength="300" autocomplete="off" placeholder="Any areas that need extra depth or are commonly misunderstood?" style="line-height:1.5;"></textarea>
        </div>
        <!-- Human verification: visible Turnstile widget. Submit button stays
             disabled until the user solves the challenge and a token is cached. -->
        <div id="ideaTurnstileContainer" style="margin-bottom:20px;min-height:0;text-align:center;"></div>
        <div class="modal-actions modal-actions--split">
          <button class="btn btn-outline btn-lg wizard-back-btn" data-proto-click="wizardNext(2)">
            Back
          </button>
          <button class="btn btn-primary btn-lg" id="ideaSubmitBtn" data-proto-click="submitIdea()" data-transient-action data-idle-label="Submit Idea" data-idle-disabled="true" disabled>Submit Idea</button>
        </div>
      </div>
    </div>
  </div>
</div>

`;
